import { ItemListRowFeaturedContent } from "@/components/item-list/rows/components/item-list-row-featured-content";
import { sortCollectionsForChips } from "@/domains/collections/sortCollectionsForChips";
import { INoteObservable } from "@/store/note";
import { truncate } from "lodash-es";
import styled from "@emotion/styled";
import { generateRelativePrepositionAdverbialDateString } from "@/domains/date/date";
import {
  MDSDialogHeaderContent,
  MDSDialogSlotName,
  MDSModalDialog,
  MDSText,
  MDSTextColor,
  MDSTextVariant,
  MDSTextWeight,
  MDSDialogChip,
  MDSDialogChipVariant,
} from "@/mds";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  note: INoteObservable;
}

export const AboutNoteModal = ({ isOpen, onClose, note }: Props) => {
  const collections = note?.collectionList?.allCollections || [];
  const hasCollections = collections.length > 0;

  return (
    <MDSModalDialog isOpen={isOpen} handleClose={onClose}>
      <StyledHeader slot={MDSDialogSlotName.Header} allowOverflow={false}>
        <MDSText variant={MDSTextVariant.HeaderL} color={MDSTextColor.Contrast}>
          About
        </MDSText>
        <MDSDialogChip
          label={truncate(note.title, { length: 50 })}
          variant={MDSDialogChipVariant.Note}
        />
      </StyledHeader>

      <StyledDialogContent slot={MDSDialogSlotName.Content}>
        <MetaData
          label="Created by"
          value={`${note.primaryOwner?.profileDisplayName} ${generateRelativePrepositionAdverbialDateString(note.locallyCreatedAt)}`}
        />
        {/* TODO: show who last edited this note when we have that data available
            <MetaData label="Last edited by" value={note.locallyModifiedAt} /> 
        */}
        <MetaData
          label="Last edited by"
          value={`${note.primaryOwner?.profileDisplayName} ${generateRelativePrepositionAdverbialDateString(note.modifiedAt)}`}
        />
        {hasCollections ? (
          <MetaData
            label="Collections"
            value={
              <ItemListRowFeaturedContent
                collections={sortCollectionsForChips(collections)}
                itemId={note.id}
                showAll
              />
            }
          />
        ) : null}
      </StyledDialogContent>
    </MDSModalDialog>
  );
};

interface MetaDataProps {
  label: string;
  value: React.ReactNode;
}
const MetaData = ({ label, value }: MetaDataProps) => {
  return (
    <MetaDataWrapper>
      <MDSText
        variant={MDSTextVariant.ParagraphSm}
        weight={MDSTextWeight.Smedium}
        color={MDSTextColor.Primary}
      >
        {label}
      </MDSText>
      <MDSText variant={MDSTextVariant.ParagraphSm} color={MDSTextColor.Primary}>
        {value}
      </MDSText>
    </MetaDataWrapper>
  );
};

const StyledHeader = styled(MDSDialogHeaderContent)`
  padding-left: ${({ theme }) => theme.spacing[3]};
`;

const StyledDialogContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[6]};
  padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[3]}`};
`;

const MetaDataWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing[1],
}));
